import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(
    private http: HttpClient,
    private commonService : CommonService
  ) {}

  
  put(url: string, data: any): Observable<any> {
    
    const put$ = new ReplaySubject<any>();
    this.http.put(url, data).subscribe({
      next: (response) => {
        put$.next(response);
      },
      complete: () => {},
      error: (err) => {
        // 
        put$.error(err);
      },
    });

    return put$.asObservable();
  }

  get(url: string): Observable<any> {
    
    const get$ = new ReplaySubject<any>();
    this.http.get(url).subscribe({
      next: (response) => {
        get$.next(response);
        
      },
      complete: () => {},
      error: (err) => {
        get$.error(err);
      },
    });

    return get$.asObservable();
  }

  post(url:string, data:any):Observable<any>{
    
    const post$ = new ReplaySubject<any>();
    this.http.post(url,data).subscribe({
      next:(response) => {
        post$.next(response);
        
      },
      complete : () => {},
      error:(err) => {
        // 
        post$.error(err);
      }
    });

    return post$;
  }
}

